import { BtnAddOnTable, BtnEditOnTable, BtnViewOnTable } from "components/Button/ButtonTable"
import { RouterDOM } from "utilities/utilities"

export interface IParamCol {
    field: string
    headerName: string
    headerAlign: "center" | "left" | "right"
    align: "center" | "left" | "right"
    resizable: boolean
    sortable: boolean
    disableReorder: boolean
    editable: boolean
    flex: number
    minWidth: number
}

export const DefaultParamCol: IParamCol = {
    field: "",
    headerName: "",
    headerAlign: "center",
    align: "center",
    resizable: false,
    sortable: true,
    editable: false,
    disableReorder: true,
    flex: 1,
    minWidth: 100
}

export function CreateColumn(
    Param: IParamCol,
    renderHeader: (item: any) => React.JSX.Element = (item) => {
        return (
            <>
                {item.value}
            </>
        );
    },
    renderCell: (item: any) => React.JSX.Element = (item) => {
        return (
            <>
                {item.value}
            </>
        );
    },
) {
    return {
        field: Param.field,
        headerName: Param.headerName,
        headerAlign: Param.headerAlign,
        sortable: Param.sortable,
        align: Param.align,
        resizable: Param.resizable,
        editable: Param.editable,
        flex: Param.flex,
        minWidth: Param.minWidth,
        renderHeader,
        renderCell
    };

}

export const BtnAddOnTableRender = ({ path, nPermision }) => {
    const Router = RouterDOM();

    const gotoPage = () => {
        Router.GoToPage(path);
    }

    return (
        <BtnAddOnTable
            id={'go-form'}
            onClick={() => gotoPage()}
        />
    )
}

export const BtnEditOnTableRender = ({ path, params, nPermision }) => {
    const Router = RouterDOM();
    const sPath = path + (params ? "?strParam=" + params.row.sID : "");

    const gotoPage = () => {
        Router.GoToPage(sPath);
    }

    if (nPermision === 1) {
        return (
            <BtnViewOnTable
                id={'go-form' + params.row.sID}
                onClick={() => gotoPage()}
            />
        )
    }
    return (
        <BtnEditOnTable
            id={'go-form' + params.row.sID}
            onClick={() => gotoPage()}
        />
    )
}


